import React__default from 'react';
import { a as CardStyled } from './Card.styles-tt0v78xU.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const CardContainer = ({
  taktId,
  taktValue,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('card')
}, /*#__PURE__*/React__default.createElement(CardStyled, restProps));

export { CardContainer as C };
//# sourceMappingURL=CardContainer-9seeKIkD.js.map
